import {RegionWithComment} from '@/components/wavesurfer_with_hook';
import {NestedComment} from '@/store/selectors/selectors';

export type ParsedTimestampWithRegions =
    | {kind: 'point'; time: number; text: string}
    | {kind: 'range'; start: number; end: number; text: string};

export const parseTimestampsWithRegions = (message: string): ParsedTimestampWithRegions[] => {
    const results: ParsedTimestampWithRegions[] = [];
    const lines = message.split(/\r?\n/);

    const regex = /([0-9]+:)?[0-9]+:[0-5][0-9](\s*-\s*([0-9]+:)?[0-9]+:[0-5][0-9])?/g;

    lines.forEach((line, i) => {
        const matches = line.matchAll(regex);
        for (const match of matches) {
            const fullMatch = match[0];

            let referenceText = line.replace(fullMatch, '').trim();
            if (referenceText === '') {
                referenceText = lines[i + 1]?.trim() || '';
            }

            if (fullMatch.includes('-')) {
                const [startRaw, endRaw] = fullMatch.split('-').map(str => str.trim());

                results.push({
                    kind: 'range',
                    start: getSecondsFromTimestamp(startRaw),
                    end: getSecondsFromTimestamp(endRaw),
                    text: referenceText,
                });
            } else {
                results.push({
                    kind: 'point',
                    time: getSecondsFromTimestamp(fullMatch.trim()),
                    text: referenceText,
                });
            }
        }
    });

    return results;
};

export const getSecondsFromTimestamp = (timestamp: string): number => {
    const parts = timestamp.split(':');

    if (parts.length === 2) {
        return (parseInt(parts[0]) * 60) + parseInt(parts[1]);
    }

    if (parts.length === 3) {
        return (parseInt(parts[0]) * 60 * 60) + (parseInt(parts[1]) * 60) + parseInt(parts[2]);
    }

    return 0;
};

export const getTimestampFromSeconds = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export const getRegionsForComments = (comments: NestedComment[]) => {
    const regions: RegionWithComment[] = [];

    for (const comment of comments) {
        const timestamps = parseTimestampsWithRegions(comment.text);

        for (const timestamp of timestamps) {
            regions.push({
                parsedTimestamp: timestamp,
                comment,
            });
        }
    }

    return regions;
};
